<template lang="pug">

  section.jumbo
    .jumbo-wrapper
      .wrap
        .col1
          p Cada década tiene su propio estilo de auto, reflejo de profundos cambios culturales que, a su vez, han impactado en las canciones que representan a cada generación. Revisa cómo ha evolucionado la música a través de tiempo, junto a la serie 200.
        .col2
          h1 Ritmo <br> Sobre Ruedas
        .col3
          h2
            img(src="assets/images/logo-peugeot.png", alt="Peugeot")
        .col4
          router-link.ready-to-go(to="/play")
            span.icon-wrap
              font-awesome-icon.icon(:icon="['fa', 'play']")
            | comienza tu experiencia

    VideoBg.elvideobg(:sources="['assets/videos/peugeot-loop.mp4']")

</template>

<script>
import { mapGetters } from 'vuex'
import VideoBg from 'vue-videobg'

export default  {
  name: 'jumbo',
  components: {
    VideoBg
  },
  props: [],
  mounted() {

  },
  data() {
    return {

    }
  },
  methods: {
    beginPlay(){
      const player = this.getPlayer;
      player.play()
    }
  },
  computed: {
    ...mapGetters([
      'getPlayer'
    ]),
  }
}
</script>

<style scoped lang="scss">
  .jumbo {
    background-color: black;
    height: 80vh;
    overflow: hidden;
    position: relative;
    @media all and (max-width: 900px){
      height: 70vh;
    }
  }
  .elvideobg{
    opacity: 0.7;
  }
  .jumbo-wrapper{
    position: absolute;
    top: 0;
    left: 3rem;
    right: 3rem;
    bottom: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    @media all and (max-width: 900px){
      left: 1rem;
      right: 1rem;
      justify-content: flex-start;
    }
  }
  .wrap{
    display: grid;
    grid-template-columns: 5fr 2fr 2fr;
    grid-gap: 2rem;
    align-items: center;
    justify-content: center;
    .col4{
      grid-column: span 3;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    @media all and (max-width: 900px){
      .col1{
        display: none;
      }
      grid-template-columns: 1fr 1fr;
    }
  }
  p{
    color: white;
    font-size: 1.2rem;
    line-height: 1.8rem;
    text-align: right;
    margin: 0;
    padding-right: 1rem;
    font-family: 'Open Sans', sans-serif;
    @media screen and (max-width: 700px){
      display: none;
    }
  }

  .ready-to-go{
    color: white;
    display: flex;
    font-family: 'Open Sans', sans-serif;
    padding: 1rem;
    font-size: 25px;
    cursor: pointer;
    text-align: center;
    position: relative;
    align-items: center;
    &:after{
      content: '';
      border: 2px solid white;
      position: absolute;
      left: 0;
      width: 68px;
      height: 68px;
      top: 0;
      border-radius: 50px;
      transition: all .3s;
    }
    .icon-wrap{
      width: 34px;
      margin-right: 24px;
      margin-left: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .icon{
      padding: 0;
    }
    &:hover{
      &:after{
        width: 102%;
      }
    }
    @media screen and (max-width: 700px){
      font-size: 21px;
      line-height: 25px;
      .icon-wrap{
        width: 24px;
        margin-right: 24px;
        margin-left: 4px;
      }
      &:after{
        width: 58px;
        height: 58px;
      }
    }
  }
  h1{
    font-size: 3.2rem;
    color: white;
    text-transform: uppercase;
    position: relative;
    padding-left: 30px;
    line-height: 2.5rem;
    &:before{
      position: absolute;
      content: '';
      left: 0;
      top: 3px;
      bottom: 7px;
      border-left: 10px solid white;
    }
    @media all and (max-width: 900px){
      font-size: 2rem;
      line-height: 1.8rem;
      padding-left: 20px;
    }
  }
</style>
